import { ROLES } from '@/shared/constants/roles';

export const careerRoutes = [
  {
    path: 'career-explorer',
    name: 'career-explorer',
    component: () => import('./views/CareerExplorerView.vue'),
    meta: { requiredRole: ROLES.STUDENT },
  },
];
